import React from "react";
import type { Plan } from "../../types";

interface Props {
  plan: Plan;
  className?: string;
}

const PlanBadge: React.FC<Props> = ({ plan, className = "" }) => {
  if (plan === "PRO") {
    return (
      <span
        className={`inline-flex items-center px-1.5 py-0.5 text-xs font-medium border border-stone-900 text-stone-900 ${className}`}
      >
        Pro
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 text-xs font-medium border border-gray-300 text-gray-500 ${className}`}
    >
      Free
    </span>
  );
};

export default PlanBadge;
